export default (state, action) => {
  return Object.assign({}, state, {
    pageNumber: action.pageNumber,
    pageLoading: true,
  });
};
